import React from 'react'
import SideBarMenu from './SideBarMenu'

const Home = () => {
    return (
        <div
            className="min-h-screen flex items-center justify-center bg-blue-900"
        >
            this is home page jdkfajkfjalfdjakljfadlkjfdklj
        </div>
    )
}

export default Home
